import * as React from 'react';
import { createPortal } from 'react-dom';

interface HeaderPortalProps {
  children: React.ReactNode;
}

const HeaderPortal: React.FC<HeaderPortalProps> = ({ children }) => {
  const [headerContainer, setHeaderContainer] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    const container = document.getElementById('header-portal');

    setHeaderContainer(container);
  }, []);

  if (!headerContainer) {
    return null;
  }

  return createPortal(children, headerContainer);
};

export default HeaderPortal;
